import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import * as managers from 'modules/domain/company/managers'
import { EntityMultiSelect, EntityMultiSelectProps } from 'views/components/EntitySelect/EntityMultiSelect'
import { SelectTestWrapper } from '../SelectTestWrapper/SelectTestWrapper'
import { PartnerType, PartnerTypeListRequestFilter } from 'modules/domain/company/types'

export type PartnerTypeSelectProps = EntityMultiSelectProps<PartnerType> & {
  details?: PartnerTypeListRequestFilter['details']
}

export const getPartnerTypeLabel = (partnerType: PartnerType) => partnerType.details
export const getPartnerTypeValue = (partnerType: PartnerType) => partnerType.id

const PartnerTypeSelect: React.FC<PartnerTypeSelectProps> = ({ details, placeholder, ...props }) => {
  const { t } = useTranslation('common')
  const memoizedFilter = useMemo(
    () => ({
      details,
    }),
    [details],
  )

  return (
    <SelectTestWrapper data-test-id={'company-type-select'}>
      <EntityMultiSelect
        placeholder={placeholder || t('placeholders.partnerTypes')}
        getEntityList={managers.fetchPartnerTypes}
        getEntityByIds={managers.getPartnerTypesByIds}
        filter={memoizedFilter}
        getOptionLabel={getPartnerTypeLabel}
        getOptionValue={getPartnerTypeValue}
        searchParamKey="title"
        {...props}
      />
    </SelectTestWrapper>
  )
}

export default PartnerTypeSelect
